import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { useSelector, useDispatch, connect } from "react-redux";

import { Link } from "react-router-dom";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";
// reactstrap

// Import menuDropdown

//i18n
import { withTranslation } from "react-i18next";

import {
  useQuery,
} from "react-query";

const Header = props => {
  const dispatch = useDispatch();

  const { profile } = useSelector(state => ({
    profile: state.Dashboard.profile
  }));

  const themeConfig = {
    logo: 'https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-logo.png',
  }

  const [isSearch, setSearch] = useState(false);

  return (
    <React.Fragment>
      <header id="page-topbar" style={{backgroundColor:"#4d43486a", backdropFilter:"blur(20px)"}}>
        <div className="navbar-header" style={{height:"60px"}}>
          <div className="d-flex">
            <div className="navbar-brand-box">
            </div>
          </div>
          <div className="d-flex">
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
